<script>
export default {
  name: 'mrfOnayList',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    rejectRecord(id) {
      this.$emit('rejectRecord', id);
    },
    approveRecord(id) {
      this.$emit('approveRecord', id);
    },
    openSaveDialog(item) {
      this.$emit('details', item);
    },
  },
};
</script>

<template>
  <tr @click="openSaveDialog(item)" style="cursor:pointer">
    <td> {{ item.mrF_No }} </td>
    <td> {{ item.mrF_Tarihi|dateWithTimeView }} </td>
    <td> {{ item.pkart }} > {{ item.proje }} </td>
    <td> {{ item.aciklama }}</td>
    <td> {{ item.teslim_Sekli }}</td>
    <td> {{ item.onay_Durumu }}</td>

    <td @click.stop>
      <v-btn @click="rejectRecord(item.pkart)" color="darken-3" small icon fat text>
        <v-icon color="red">
          mdi-close
        </v-icon>
      </v-btn>
    </td>
    <td @click.stop>
      <v-btn @click="approveRecord(item.pkart)" color="darken-3" small icon fat text>
        <v-icon color="success">
        mdi-check
      </v-icon>
      </v-btn>
    </td>
  </tr>
</template>
